import { encodeId } from './encryption';

function toCamelCase(str) {
  return str.replace(/_([a-z0-9])/g, (_, g) => g.toUpperCase());
}

function toSnakeCase(str) {
  return str.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);
}

export function compileRoute(routePattern, payload = {}) {
  if (!routePattern) return null;
  const safePayload =
    typeof payload === 'object' && payload !== null ? payload : {};

  // Replace dynamic parameters (:param) with encoded values from payload
  let compiled = routePattern.replace(/:([a-zA-Z0-9_]+)/g, (match, key) => {
    const val =
      safePayload[key] ??
      safePayload[key.toLowerCase()] ??
      safePayload[toCamelCase(key)] ??
      safePayload[toSnakeCase(key)] ??
      (key.toLowerCase().endsWith('id')
        ? (safePayload.id ?? safePayload._id ?? safePayload.pk)
        : undefined) ??
      '';

    if (val !== '' && val !== null && val !== undefined) {
      try {
        return encodeURIComponent(encodeId(String(val)));
      } catch {
        return encodeURIComponent(String(val));
      }
    }
    return '';
  });

  // Clean up paths with missing path segments (e.g. /reminders/import/ -> /reminders/import)
  if (compiled.includes('?')) {
    const [pathPart, queryPart] = compiled.split('?');
    const cleanedPath = pathPart.replace(/\/+$/, '') || '/';
    const validParams = (queryPart || '').split('&').filter((p) => {
      if (!p || !p.includes('=')) return false;
      const val = p.split('=')[1];
      return val !== '' && val !== null && val !== undefined;
    });
    compiled =
      validParams.length > 0
        ? `${cleanedPath}?${validParams.join('&')}`
        : cleanedPath;
  } else {
    compiled = compiled.replace(/\/+$/, '') || '/';
  }

  return compiled;
}
